module.exports = __webpack_public_path__ + "img/1104.47be14f2.jpg";